import DialogPopupText from './DialogPopupText'

export default DialogPopupText
